import { render, staticRenderFns } from "./Flexbox.vue?vue&type=template&id=27be6e96"
import script from "./Flexbox.vue?vue&type=script&lang=js"
export * from "./Flexbox.vue?vue&type=script&lang=js"
import style0 from "./Flexbox.vue?vue&type=style&index=0&id=27be6e96&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27be6e96')) {
      api.createRecord('27be6e96', component.options)
    } else {
      api.reload('27be6e96', component.options)
    }
    module.hot.accept("./Flexbox.vue?vue&type=template&id=27be6e96", function () {
      api.rerender('27be6e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flexbox/Flexbox.vue"
export default component.exports